import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import * as actions from '../action';
import * as c from '../constant';

function GeneralRevisionContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  generalRevisionId,
  getSingleGeneralRevision,
  generalRevisionInfo,
}) {
  const permissions = getJson('permissions');

  useEffect(() => {
    if (_.isEmpty(generalRevisionId)) return;
    getSingleGeneralRevision(generalRevisionId);
  }, []);

  useEffect(() => {
    if (_.isEmpty(generalRevisionId)) return;
    getSingleGeneralRevision(generalRevisionId);
  }, [generalRevisionId]);

  return (
    <div className="container-fluid card-section-content">
      {Acl(permissions, ['E2E RPT SETTINGS CREATE GENERAL REVISIONS']) && (
        <div className="row bg-white pr-2 py-2 mb-2">
          <div className="col-12 d-flex">
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-round font-weight-bold px-4 ml-auto"
            >
              Add&nbsp;
              <i className="fas fa-plus" />
            </button>
          </div>
        </div>
      )}
      {!_.isEmpty(generalRevisionInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="row d-flex justify-content-between align-items-center">
                <div className="col-10">
                  <h3 className="">Information</h3>
                </div>
                <div className="col-2 d-flex">
                  <div className="ml-auto">
                    {Acl(permissions, [
                      'E2E RPT SETTINGS UPDATE GENERAL REVISIONS',
                    ]) && (
                      <button
                        type="button"
                        className="btn-blank"
                        onClick={handleEdit(generalRevisionInfo)}
                      >
                        <i className="far fa-edit icon-edit" />
                      </button>
                    )}
                    {Acl(permissions, [
                      'E2E RPT SETTINGS DELETE GENERAL REVISIONS',
                    ]) && (
                      <button
                        type="button"
                        className="btn-blank"
                        onClick={handleRemove(generalRevisionInfo)}
                      >
                        <i className="far fa-trash-alt icon-delete" />
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12">
                    <div className="form-wrapper mb-3">
                      <div className="full-group border-bottom p-3">
                        <table className="transaction-table table table-borderless table-sm">
                          <tbody>
                            <tr>
                              <td className="text-dark" width="200">
                                Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(
                                    generalRevisionInfo,
                                    'attributes.name'
                                  ) || '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="200">
                                Revision Indicator
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(
                                    generalRevisionInfo,
                                    'attributes.revision_indicator'
                                  ) || '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="200">
                                Ordinance Revision
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(
                                    generalRevisionInfo,
                                    'attributes.ordinance_revision_id'
                                  ) || '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="200">
                                Status
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(
                                    generalRevisionInfo,
                                    'attributes.status'
                                  ) || '--'}
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

GeneralRevisionContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  getSingleGeneralRevision: PropTypes.instanceOf(Function).isRequired,
  generalRevisionInfo: PropTypes.instanceOf(Object).isRequired,
  generalRevisionId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  generalRevisionInfo:
    _.get(api, `${c.GET_SINGLE_GENERAL_REVISION}.item`) || {},
  generalRevisionId: _.get(match, 'params.generalRevisionId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(GeneralRevisionContent);
